// File: frontend/src/context/AuthContext.js

import React, { createContext, useState, useContext, useEffect } from 'react';
import * as api from '../services/api'; 

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    // 1. Load User from LocalStorage
    useEffect(() => {
        const storedUser = localStorage.getItem('userInfo');
        if (storedUser) {
            try {
                setUser(JSON.parse(storedUser));
            } catch (error) {
                console.error("Failed to parse user info:", error);
                localStorage.removeItem('userInfo');
                localStorage.removeItem('token');
            }
        }
        setLoading(false);
    }, []);

    // 2. Login Function (Corrected for your Backend)
    const login = async (formData) => {
        try {
            // API Call
            const { data } = await api.login(formData);
            
            // Backend sends flat data: { _id, name, email, role, token }
            console.log("Login Success Data:", data);

            // Set State
            setUser(data);

            // Set LocalStorage
            localStorage.setItem('userInfo', JSON.stringify(data));
            localStorage.setItem('token', data.token); 

            return data; // Return user data for redirection logic
        } catch (error) {
            console.error("Login Failed:", error.response?.data?.message || error.message);
            throw error;
        }
    };

    // 3. Logout Function
    const logout = () => {
        localStorage.removeItem('userInfo');
        localStorage.removeItem('token');
        setUser(null);
        window.location.href = '/'; // Full refresh helps clear state
    };

    // 4. Register Function (Optional)
    const register = async (formData) => {
        const { data } = await api.registerUser(formData);
        setUser(data);
        localStorage.setItem('userInfo', JSON.stringify(data));
        localStorage.setItem('token', data.token);
        return data;
    };

    return (
        <AuthContext.Provider value={{ user, login, logout, register, loading }}>
            {!loading && children}
        </AuthContext.Provider>
    );
};

export default AuthContext;